import * as React from 'react';
import {connect} from "react-redux";
import {Notification} from "../../models/Notification";
import {ApplicationState} from "../../store";
import {NotificationList}  from '../components/NotificationList';
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {
	actionNotificationFetchAll,
	actionDeleteNotifications, actionNotificationDelete
} from '../../store/notifications/actions';

import {t} from "../../core/localization";
import NotificationsService from "../../services/NotificationsService";

export interface DashboardTabProps {
	notifications: Notification[]
	tab: Tab
}

export interface DashboardTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		notifications: state.notifications.list,
		tab: state.tabs.active
	};
}

class DashboardTab extends React.Component<DashboardTabProps, DashboardTabState> {

	constructor(props: DashboardTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: DashboardTabProps) {
	}

	componentDidMount() {
		actionNotificationFetchAll();
	}

	onNotificationOpenClick(notification: Notification) {
		notification.seen = true
		const action = NotificationsService.parseAction(notification)
		if (action) {
			TabsService.createTab(notification.title, action.tabType, { id: action.id})
		}
	}

	onNotificationDeleteClick(notification: Notification){
		actionNotificationDelete(notification);
	}

	onActionDeleteClick(notifications: Notification[]){
		actionDeleteNotifications(notifications);
	}

	render(): React.ReactNode {

		const {notifications} = this.props;

		const columns = [
			new ColumnData(t.Name, "title" ),
			new ColumnData(t.Description, "description" ),
			new ColumnData(t.Seen, 'seen')
		];

		return (
			<div style={{padding: '10px'}}>
				{/*<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewNotification}</Button></div>*/}
				<NotificationList
					columns={columns}
					items={notifications}
					title={"Dashboard"}
					onOpenClick={(notification: Notification) => {
						this.onNotificationOpenClick(notification)
						notification.seen=true
					}}
					onDeleteClick={(notification: Notification) => this.onNotificationDeleteClick(notification)}
					onActionDeleteClick={(notifications: Notification[]) => this.onActionDeleteClick(notifications)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	onNewClick() {
		// TabsService.createTab(t.NewNotification, TabTypes.NOTIFICATIONS_NEW, new Notification())
	}
}

export default connect(mapStateToProps)(DashboardTab);
